






import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class XCard extends Vue {
    /**
     * 当前日期
     * @config
     * @protected
     */
    @Prop({type: Boolean, default: true })
    protected isPage: boolean;

    protected tstyle: any = {
        "padding-bottom": "0px",
        "margin-bottom": "10px",
    };
}
